module.exports = __webpack_public_path__ + "img/33.10842c49.png";